import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import styled from 'styled-components';
var FilterTag = styled.div({
    display: 'inline-flex',
    alignItems: 'center',
    height: '32px',
    backgroundColor: '#f2f2f2',
    boxSizing: 'border-box',
    padding: '7px 10px',
    borderRadius: '4px',
    '&:not(:first-child)': {
        marginLeft: '10px',
    },
});
var FilterTagText = styled.span({
    color: '#343434',
    fontFamily: 'var(--font-family-primary)',
    fontWeight: 'normal',
    fontSize: '15px',
});
export var FilterTags = function (_a) {
    var items = _a.items;
    return (_jsx(_Fragment, { children: items.map(function (item) { return (_jsx(FilterTag, { children: _jsx(FilterTagText, { children: item.name }, void 0) }, item.id)); }) }, void 0));
};
